import React, { useEffect, useState } from 'react'
import Header from '../../components/header/Header'
import Posts from '../../components/posts/Posts'
import Sidebar from '../../components/sidebar/Sidebar'
import './home.css'
import axios from "axios";
import { useLocation } from 'react-router-dom'
import Error from '../../components/error/Error'
import Modal from '../../components/modal/Modal'

function Home() {
  const [posts, setPosts] = useState([]);
  const location = useLocation();
  const [fetching, setFetching] = useState(false);
  const [pageload, setPageload] = useState(1);

  useEffect(() => {
    setFetching(true);
    const fetchPosts = async () => {
      const res = await axios.get(`https://mernblogbackend.onrender.com/api/posts/${location.search}`);
      setFetching(false);
      setPosts(res.data);
      setPageload(pageload++);
    }
    fetchPosts();
  }, [location.search]);

  console.log(posts);


  return (
    <>
      <Header />
      <div className='home'>
        {(posts.length === 0) ? <Error /> : <Posts posts={posts} />}
        {
          (
            fetching &&
            <Modal crossButton={false}>
              <div>
                <div className="loader"></div>
                {pageload === 1 && <div className="loadMessage">Please wait for the backend to load. <br></br>It may take around 15sec. Sorry for the inconvenience.</div>}
              </div>
            </Modal>
          )
        }
        <Sidebar />
      </div>
    </>
  )
}

export default Home